import React from 'react';
import { Send } from 'lucide-react';

interface ChatInputProps {
  value: string;
  onChange: (value: string) => void;
  onSend: () => void;
  isDisabled: boolean;
  inputRef: React.RefObject<HTMLTextAreaElement>;
}

/**
 * Component for rendering the chat input field
 */
export function ChatInput({ value, onChange, onSend, isDisabled, inputRef }: ChatInputProps) {
  const handleKeyDown = (e: React.KeyboardEvent) => {
    // Always block Enter (without Shift) to prevent newline insertion
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      // Only send if not disabled and has content
      if (!isDisabled && value.trim()) {
        onSend();
      }
    }
  };

  return (
    <div className="flex-shrink-0 border-t border-surface-600 p-4">
      <div className="flex items-end gap-2">
        <textarea
          ref={inputRef}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="Message about this task..."
          rows={1}
          className="flex-1 resize-none bg-surface-800 border border-surface-600 rounded-lg px-3 py-2 text-sm text-text-primary placeholder:text-text-muted focus:outline-none focus:border-primary-500 min-h-[40px] max-h-[120px]"
          style={{ height: 'auto' }}
        />
        <button
          onClick={onSend}
          disabled={isDisabled || !value.trim()}
          aria-label="Send message"
          className="p-2 bg-primary-500 hover:bg-primary-400 disabled:bg-surface-700 disabled:text-text-muted text-surface-900 rounded-lg transition-colors"
        >
          <Send className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
